export interface Item extends Object {
  [prop: string]: any;
}

export type ItemFactory<T extends Item> = (key: number, text: string) => T;

export function mapToKeys<T extends Item>(items: T[], itemKeyProperty: string): number[] {
  return items.map((item) => item[itemKeyProperty]);
}

export function getItemPropertyValue<T extends Item>(item: T, itemPropertyName: string) {
  return item ? item[itemPropertyName] : null;
}
